import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import { Button, DialogActions, DialogContent } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function DialogBox({
  width,
  openPopup,
  mesage,
  onClose,
  setOpenPopup,
  dividers,
  title,
  titleClass = "",
  content,
  footer,
  contentClassName,
  fullScreenModal,
  dialogParentClass = "",
  closeButtonClass = "",
  constrainToViewport = true,
  showCloseButton = true,
}) {
  return (
    <div>
      <Dialog
        maxWidth={width ? width : "sm"}
        scroll="paper"
        sx={{
          textAlign: "center",
          ...(constrainToViewport
            ? {
                "& .MuiDialog-paper": {
                  maxHeight: "90vh",
                  display: "flex",
                  flexDirection: "column",
                },
              }
            : {}),
        }}
        fullWidth={true}
        open={openPopup}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={fullScreenModal ? "zoom-modal-wrapper" : dialogParentClass}
      >
        <DialogTitle
          id="alert-dialog-title"
          className="p-0"
          sx={{ flexShrink: 0 }}
        >
          {title && <p className={`m-3 ${titleClass}`}>{title}</p>}
          {onClose && showCloseButton && (
            <Button
              onClick={() => onClose()}
              className={`modal-close-btn ${
                fullScreenModal && "close-text-a"
              } ${closeButtonClass}`}
              style={{
                position: "absolute",
                right: 10,
                top: 15,
                background: "transparent",
                textTransform: "none",
              }}
            >
              {fullScreenModal && "Close"}
              <CloseIcon sx={{ color: "#9CB8A6" }} />
            </Button>
          )}
        </DialogTitle>
        <DialogContent
          className={contentClassName}
          dividers={dividers}
          sx={{
            flex: "1 1 auto",
            minHeight: 0,
            overflowY: "auto",
            overscrollBehavior: "contain",
            WebkitOverflowScrolling: "touch",
          }}
        >
          {content}
        </DialogContent>
        {footer && <DialogActions sx={{ flexShrink: 0 }}>{footer}</DialogActions>}
      </Dialog>
    </div>
  );
}
